// @ts-nocheck
import { useDrag } from 'react-dnd';
import { useDispatch, useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';
import { hooks as commonHooks } from '@sitebuilder/common';
import { StateShape as ReduxStateShape } from '../reducers';
import { searchGreySvg, widgetsSvg } from '../assets/images';
import { SideBarAccordion } from '../components/BaseComponents';
import { actionCreators as componentCreators } from '../reducers/components';
import { actionCreators as publicComponentCreators } from '../reducers/publicComponents';
interface WidgetProps {
    id: string;
    label?: string;
    icon?: string;
    isRefComponent?: boolean;
    isPublicRefComponent?: boolean;
    childern?: JSX.Element | JSX.Element[];
}

const Widget: React.FC<WidgetProps> = ({
    id,
    label,
    icon,
    isRefComponent,
    isPublicRefComponent,
}): JSX.Element => {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'WIDGET',
        item: () => {
            return { id, isRefComponent, isPublicRefComponent, dragMode: 'create' };
        },
        collect: (monitor: any) => ({
            isDragging: monitor.isDragging(),
        }),
    }));

    return (
        <div
            ref={drag}
            style={{ opacity: isDragging ? 0.5 : 1 }}
            className="btn btn--outline widget-button"
        >
            {icon != null || undefined ? (
                ''
            ) : (
                <img src={widgetsSvg} alt="widget icon" className="icon-widget" />
            )}
            {label || 'Untitled'}
        </div>
    );
};

interface WidgetGalleryProps {
    childern?: JSX.Element | JSX.Element[];
}

const WidgetGallery: React.FC<WidgetGalleryProps> = (): React.ReactElement => {
    const [widgetSearch, setwidgetSearch] = useState('');
    const [accordionActiveKeys, setAccordionActiveKeys] = useState(['0']);
    const dispatch = useDispatch();

    const appContext = commonHooks.useAppContext();

    const { components } = useSelector((state: ReduxStateShape) => state.components);
    const { components: publicComponents } = useSelector(
        (state: ReduxStateShape) => state.publicComponents
    );

    useEffect(() => {
        if (components === null) {
            // to pull max of 1000 reference components
            dispatch(componentCreators.listComponents('public', '', false, {}, {}, {}, 1000, 0));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [components]);

    useEffect(() => {
        if (publicComponents === null) {
            // to pull max of 1000 reference components
            dispatch(
                publicComponentCreators.listComponents('public', '', false, {}, {}, {}, 1000, 0)
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [publicComponents]);

    const widgets: any = {
        data: { group: [], id: 'data', title: 'Data' },
        table: { group: [], id: 'tables', title: 'Tables' },
        charts: { group: [], id: 'charts', title: 'Charts' },
        graphics: { group: [], id: 'graphics', title: 'Images and Graphics' },
        component: { group: [], id: 'component', title: 'Components' },
        button: { group: [], id: 'buttons', title: 'Buttons' },
        layout: { group: [], id: 'layout', title: 'Layout' },
        others: { group: [], id: 'others', title: 'Others' },
    };

    const onClickAccordion = (eventKey: string) => {
        if (accordionActiveKeys.includes(eventKey)) {
            setAccordionActiveKeys(accordionActiveKeys.filter((k) => k !== eventKey));
        } else if (eventKey) {
            setAccordionActiveKeys([eventKey]);
        }
    };

    // Handles search functioanlity for widgets
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setwidgetSearch(e.target.value);
        const AccordionDivs = document.querySelectorAll<HTMLElement>('.left-sidebar-accordion');
        const AccordionTitle = document.querySelectorAll<HTMLElement>(
            '.left-sidebar-accordion-toggle'
        );
        const activeAccordions = [...accordionActiveKeys];

        Array.from(AccordionDivs).forEach((node: any) => {
            if (node.textContent!.toLowerCase().indexOf(e.target.value.toLowerCase()) >= 0) {
                node.style.display = 'block';
                Array.from(AccordionTitle).forEach((node: any, index: any) => {
                    const AccordionData = node.nextSibling.querySelectorAll('.widget-button');

                    if (
                        node.textContent!.toLowerCase().indexOf(e.target.value.toLowerCase()) >= 0
                    ) {
                        if (!activeAccordions.includes(`${index}`)) {
                            activeAccordions.push(`${index}`);
                        }

                        Array.from(AccordionData).forEach((node: any) => {
                            node.style.display = 'flex';
                        });
                    } else {
                        Array.from(AccordionData).forEach((node: any) => {
                            if (
                                node
                                    .textContent!.toLowerCase()
                                    .indexOf(e.target.value.toLowerCase()) >= 0
                            ) {
                                if (!activeAccordions.includes(`${index}`)) {
                                    activeAccordions.push(`${index}`);
                                }

                                node.style.display = 'flex';
                            } else {
                                node.style.display = 'none';
                            }
                        });
                    }
                });
            } else {
                node.style.display = 'none';
            }
        });

        if (!e.target.value.length) {
            setAccordionActiveKeys(['0']);
        } else {
            setAccordionActiveKeys(activeAccordions);
        }
    };

    return (
        <div className="widget-gallery">
            <h3 className="sidebar-header">Widgets</h3>
            <>
                <div className="widgets-container">
                    <div className="input-search-widget">
                        <img src={searchGreySvg} alt="Search icon" />
                        <input
                            type="text"
                            placeholder="All Widgets"
                            value={widgetSearch}
                            onChange={handleChange}
                            className={'input-textfield'}
                        />
                    </div>
                    {appContext.widgetFactory.listWidgetIds().forEach((widgetId) => {
                        const v = appContext.widgetFactory.getWidget(widgetId);
                        if (v.group) {
                            widgets?.[v.group]?.group?.push(
                                <React.Fragment key={v.id}>
                                    <Widget
                                        id={v.id}
                                        label={
                                            typeof v.schema === 'function'
                                                ? v.schema({}).title
                                                : v.schema.title
                                        }
                                        icon={v.icon}
                                    />
                                </React.Fragment>
                            );
                        }
                    })}
                    <hr className="divider" />
                    <div className="widgets-list">
                        {Object.keys(widgets).map((key: string, index: number) => (
                            <>
                                {widgets?.[key]?.group?.length > 0 && (
                                    <SideBarAccordion
                                        toggleTitle={widgets?.[key]?.title}
                                        eventKey={index.toString()}
                                        key={index}
                                        className="left-sidebar-accordion"
                                        toggelClassName="left-sidebar-accordion-toggle"
                                        accordionActiveKey={accordionActiveKeys}
                                        onClickAccordion={onClickAccordion}
                                    >
                                        {widgets?.[key]?.group}
                                    </SideBarAccordion>
                                )}
                            </>
                        ))}
                    </div>
                </div>
            </>
        </div>
    );
};

export default WidgetGallery;
